import React from 'react';

const MoreButton = ({ fill = 'white', props }) => (
  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="19" cy="19" r="18.5" fill={fill} stroke="#EEEEEE" />
    <path
      d="M19 19.9166C19.5063 19.9166 19.9167 19.5062 19.9167 19C19.9167 18.4937 19.5063 18.0833 19 18.0833C18.4938 18.0833 18.0834 18.4937 18.0834 19C18.0834 19.5062 18.4938 19.9166 19 19.9166Z"
      fill="#3F3C43"
      stroke="#3F3C43"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 13.5C19.5063 13.5 19.9167 13.0896 19.9167 12.5834C19.9167 12.0771 19.5063 11.6667 19 11.6667C18.4938 11.6667 18.0834 12.0771 18.0834 12.5834C18.0834 13.0896 18.4938 13.5 19 13.5Z"
      fill="#3F3C43"
      stroke="#3F3C43"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 26.3333C19.5063 26.3333 19.9167 25.9229 19.9167 25.4167C19.9167 24.9104 19.5063 24.5 19 24.5C18.4938 24.5 18.0834 24.9104 18.0834 25.4167C18.0834 25.9229 18.4938 26.3333 19 26.3333Z"
      fill="#3F3C43"
      stroke="#3F3C43"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MoreButton;
